import { BaseViewStore } from 'core/stores';
import { OnHoldForm } from 'modules/order/forms';
import { action, makeObservable } from 'mobx';
import OrderStore from './OrderStore';
import { LookupStore } from 'modules/lookup/stores';
import { lookupRouteName, sourceOfChange } from 'common/constants';
import { isSome, notificationError, translate } from 'core/utils';
import { BaasicDropdownViewStore } from 'common/stores';
import _ from 'lodash';

class MarketplaceOrderOnHoldViewStore extends BaseViewStore {
	selectedItem = null;
	debouncedOnHoldSearch = null;

	form = new OnHoldForm({
		onSuccess: async () => {
			await this.onHold();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.lookupStore = new LookupStore(rootStore);
		this.orderStore = new OrderStore(rootStore);
		this.initialize(this.modalParams.data.id);
	}

	@action.bound
	initialize = async id => {
		this.suspend();
		this.order = await this.orderStore.getOrder(id, {
			embed: ['onHoldReason'],
		});
		this.onHoldReasonDropdownStore = new BaasicDropdownViewStore({
			store: new LookupStore(this.rootStore),
			value: this.setInitialOnHoldReason(),
			field: this.form.$('onHoldReasonId'),
			lookupRoute: lookupRouteName.onHoldReason,
			filterCallback: this.filterOnHoldReason,
		});
		this.resume();
	};

	@action.bound
	setInitialOnHoldReason = () => {
		if (this.order && this.order.onHoldReason != null) {
			return {
				value: this.order.onHoldReasonId,
				label: this.order.onHoldReason.name,
			};
		}
	};

	@action.bound
	onHold = async () => {
		try {
			const { onHoldReasonId } = this.form.values();
			const onHoldParams = { orderId: this.order.id, onHoldReasonId: onHoldReasonId };
			await this.orderStore.onHold(onHoldParams, sourceOfChange.onHoldAction);
			if (this.onHoldReasonDropdownStore.value != null) {
				this.rootStore.notificationStore.success([
					'MARKETPLACEORDERONHOLDVIEW.SUCCESS',
					{ id: this.order.orderNumber },
				]);
			} else {
				this.rootStore.notificationStore.success([
					'MARKETPLACEORDERONHOLDVIEW.CLEAREDONHOLD',
					{ id: this.order.orderNumber },
				]);
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	};
}

export default MarketplaceOrderOnHoldViewStore;
